import { useSignAndSendTransaction } from "./use-sign-and-send-transaction.js";
export const useSignTransaction = () => {
    console.info('useSignTransaction will be renamed to useSignAndSendTransaction in the ' +
        'next major release of the React SDK.');
    const { signAndSendTransaction } = useSignAndSendTransaction();
    return { signTransaction: signAndSendTransaction };
};
//# sourceMappingURL=use-sign-transaction.js.map